import React, { useEffect, useState } from 'react'
import ModalBox from '../../../components/modal/ModalBox'
import useButtonLoader from '../../../hooks/UseButtonLoader'
import { changeModeratorApi, getMemberListApi } from '../../../services/community'
import { catchMessage, elseMessage, successMessage } from '../../../comman/Message'
import NotFound from '../../../components/not-found/NotFound'
import WcIcon from '@mui/icons-material/Wc';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import useFullPageLoader from '../../../hooks/useFullPageLoader'
import { AvatarImg } from '../../../comman/avatar/Avatar'
import { PaginationShow } from '../../../comman/action/Pagination'

const ChangeModerator = ({ show, close, id, listing, newModerator }) => {
    const [buttonref, buttonLoader] = useButtonLoader("Change")
    const [membersList, setMembersList] = useState([])
    const [total, setTotal] = useState(0);
    const [page, setPage] = useState(1)
    const [moderator, setModerator] = useState('')
    const [loader, showLoader, hideLoader] = useFullPageLoader()

    const [buttonText, setButtonText] = useState('');

    // console.log('newModerator', newModerator)
    // console.log('moderator', moderator)
    //------------Handel-radio-button-------------
    const handleChange = (e) => {
        setModerator(e.target.value)
        if (moderator === e.target.value) {
            setModerator('')
        }
    }
    //------------Handel-Pagination-------------
    const handlePageChange = (event) => {
        setPage(event)
    };
    //------------modal-close-------------
    const modalClose = () => {
        setModerator(null)
        // setMembersList([])
        close()
    };
    //-----------------member-listing-Api-----------------------------
    const getMemberList = async (
        activePage = page
    ) => {
        try {
            showLoader()
            setMembersList([])
            const res = await getMemberListApi(id, { page: activePage })
            if (res?.data?.status === 200) {
                const memberArr = res?.data?.data?.memberList
                hideLoader()
                setMembersList(memberArr || [])
                setTotal(res?.data?.data?.total || 0)
                setModerator(memberArr.find(data => data.role === "moderator")?._id || null)
            } else {
                hideLoader()
                elseMessage(res)
                setMembersList([])
            }
        } catch (err) {
            hideLoader()
            catchMessage(err)
        }
    }
    //-----------------member-listing-Api-----------------------------
    const changeModerator = async () => {
        const data = { newModeratorId: moderator, communityId: id }
        try {
            buttonLoader(true)
            const res = await changeModeratorApi(data)
            if (res?.data?.status === 200) {
                buttonLoader(false)
                modalClose()
                successMessage(res)
                listing()
                setModerator(null)
            } else {
                buttonLoader(false)
                elseMessage(res)
            }
        } catch (err) {
            buttonLoader(false)
            catchMessage(err)
        }
    }
    useEffect(() => {
        getMemberList(page)
    }, [show, id, page])

    useEffect(() => {
        if (moderator) {
            setButtonText('Change');
        } else if (newModerator && !moderator) {
            setButtonText('');
        }
        // else if (moderator === null) {
        //     setButtonText('');
        // }
        else {
            setButtonText('Remove');
        }
    }, [moderator, newModerator]);

    return (
        <ModalBox

            status={show}
            onClose={close}
            title={newModerator ? 'Add Moderator' : 'Change Moderator'}
            custom
            size={"md"}
            customizedFooter={
                <>
                    {buttonText && (
                        <button className='btn_size' ref={buttonref} onClick={changeModerator}>
                            {newModerator ? "Add" : buttonText}
                            {/* {buttonText} */}

                        </button>
                    )}
                    <button className='btn_size' onClick={modalClose}>close</button>
                </>}
        >
            <div className="content-table mt-0 mb-0">
                {loader}
                <table>
                    <thead>
                        <tr>
                            <th>S. No.</th>
                            <th>Profile</th>
                            <th>Members Name </th>
                            <th>User ID</th>
                            <th className="text-center"> Action </th>
                        </tr>
                    </thead>

                    <tbody>
                        {membersList.length > 0 ? membersList.filter(member => member?.role !== 'admin').map((
                            {
                                name,
                                username,
                                _id,
                                profile,
                            }, index) => {
                            return (
                                <React.Fragment key={index}>
                                    <tr>
                                        <td>{++index + (page - 1) * 10}</td>
                                        <td>
                                            <AvatarImg id={_id} image={profile} />
                                        </td>
                                        <td>{name || "N/A"}</td>
                                        <td>{username || "N/A"}</td>
                                        <td>
                                            <div className="d-flex justify-content-center">
                                                <RadioGroup row
                                                    aria-labelledby="demo-row-radio-buttons-group-label"
                                                    name="user"
                                                    value={moderator || ""}
                                                    onClick={handleChange}
                                                >
                                                    <FormControlLabel value={_id} control={<Radio />} />
                                                </RadioGroup>
                                            </div>
                                        </td>
                                    </tr>
                                </React.Fragment>
                            )
                        }) :
                            <NotFound
                                cols={6}
                                msg="No members Found!"
                                icon={<WcIcon style={{ fontSize: 48 }} />}
                            // loader={loader}
                            />
                        }
                    </tbody>
                </table>
            </div>
            <PaginationShow
                total={total}
                activePage={page}
                handlePageChange={handlePageChange}
            />
        </ModalBox >
    )
}

export default ChangeModerator